import useRoutes from 'hooks/use-routes';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useStoreContext } from 'state/store';
import { routes } from 'utils/routing';

export const useOrderHref = ({ forceStoreChange }: { forceStoreChange?: boolean } = {}) => {
  const { store } = useStoreContext();
  const deliveryEnabled = useFlag(LaunchDarklyFlag.ENABLE_DELIVERY);
  const { getLocalizedRouteForPath } = useRoutes();

  const route = deliveryEnabled ? routes.serviceMode : getLocalizedRouteForPath('store-locator');

  if (forceStoreChange) {
    return route;
  }

  return store.hasSelection ? routes.menu : route;
};
